{#await Promise.all([event_obj, event_data]) then [ev, ev_data]}
    {#if ev_data.showPrices}
        <div class="table-header" role="rowgroup">
            <div class="row" role="row">
                <div role="columnheader" class="col-4 d-none d-sm-block">{ $_("unseated.header.category") }</div>
                <div role="columnheader" class="col-4 col-sm-2">{ $_("unseated.header.price") }</div>
                <div role="columnheader" class="col-8 col-sm-4">{ $_("unseated.header.amount") }</div>
                <div role="columnheader" class="col-2 d-none d-sm-block text-right">{ $_("unseated.header.sum") }</div>
            </div>
        </div>

        <div class="table-body" role="rowgroup">
            {#each ev.categories as category (category.id)}
                {#await category.contingent() then contingent}
                    {#if category.discounts.length > 0 || category.offerDefaultPrice}
                        <div class="row" role="row">
                            <div class="col-12 col-sm-4" role="rowheader">{ category.name }</div>
                            {#if category.offerDefaultPrice}
                                <div class="col-4 col-sm-2 price" role="cell" aria-label={$_("accessibility.select.unseated.category.price", [category.name, netto_func(category.price)/100], ["category", "price"])}>{ l(netto_func(category.price)/100) }</div>
                            {:else}
                                <div class="col-4 col-sm-2" role="cell"></div>
                            {/if}
                            {#if ev_data.doSell && category.offerDefaultPrice}
                                {#if contingent > 0}
                                    <div class="col-8 col-sm-4" role="cell">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <button 
                                                    class="btn btn-secondary" 
                                                    on:click={((k) => () => increment(k, -1, contingent))(build(event_id, category.id))}
                                                    aria-label={$_("accessibility.select.unseated.category.remove", [category.name], ["category"])}
                                                >
                                                    <i class="fa fa-minus" />
                                                </button>
                                            </div>
                                            <label for={`${category.id}-std`}>
                                                { $_("accessibility.select.unseated.category.count", [category.name], ["category"]) }
                                            </label>
                                            <input 
                                                class="form-control"
                                                type="text"
                                                inputmode="numeric"
                                                pattern="[0-9]*"
                                                name={`${category.id}-std`}
                                                value={$catMap[build(event_id, category.id, null)]||0}
                                                on:input|preventDefault={((k) => (e) => updateInput(e, k, contingent))(build(event_id, category.id, null))}
                                                aria-label={$_("accessibility.select.unseated.category.count", [category.name], ["category"])}
                                            />
                                            <div class="input-group-append">
                                                <button 
                                                    class="btn btn-secondary" 
                                                    on:click={((k) => () => increment(k, 1, contingent))(build(event_id, category.id))}
                                                    aria-label={$_("accessibility.select.unseated.category.add", [category.name, netto_func(category.price)/100.0], ["category", "price"])}
                                                >
                                                    <i class="fa fa-plus" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                {:else}
                                    <div class="col-8 col-sm-4" role="cell">
                                        <span class="badge badge-danger">{ $_("unseated.sold-out") }</span>
                                    </div>
                                {/if}
                            {:else}
                                <div class="col-8 col-sm-4" role="cell">
                                </div>
                            {/if}
                            {#if category.offerDefaultPrice}
                                <div class="col-2 d-none d-sm-block text-right price" aria-label={$_("accessibility.select.unseated.category.sum", [category.name, netto_func(category.price)/100*($catMap[build(event_id, category.id, null)]|0)], ["category", "price"])}>
                                    { l(netto_func(category.price)/100*($catMap[build(event_id, category.id)]||0)) }
                                </div>
                            {:else}
                                <div class="col-2 d-none d-sm-block"></div>
                            {/if}
                        </div>
                    {/if}

                    {#each category.discounts as discount (discount.id)}
                        <div class="row" role="row">
                            <div class="col-12 col-sm-4" role="rowheader" aria-label={`${category.name} — ${discount.name}`}>&mdash; { discount.name }</div>
                            <div class="col-4 col-sm-2" role="cell" aria-label={$_("accessibility.select.unseated.discount.price", [category.name, discount.name, netto_func(discount.price)/100], ["category", "discount", "price"])}>{ l(netto_func(discount.price)/100) }</div>
                            {#if ev_data.doSell}
                                {#if contingent > 0}
                                    <div class="col-8 col-sm-4" role="cell">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <button 
                                                    class="btn btn-secondary" 
                                                    on:click={((k) => () => increment(k, -1, contingent))(build(event_id, category.id, discount.id))}
                                                    aria-label={$_("accessibility.select.unseated.discount.remove", [category.name, discount.name], ["category", "discount"])}
                                                >
                                                    <i class="fa fa-minus" />
                                                </button>
                                            </div>
                                            <label for={`${category.id}-${discount.name}`}>
                                                { $_("accessibility.select.unseated.discount.count", [category.name, discount.name], ["category", "discount"]) }
                                            </label>
                                            <input 
                                                class="form-control"
                                                type="text"
                                                inputmode="numeric"
                                                name={`${category.id}-${discount.name}`}
                                                pattern="[0-9]*"
                                                value={$catMap[build(event_id, category.id, discount.id)]||0}
                                                on:input|preventDefault={((k) => (e) => updateInput(e, k, contingent))(build(event_id, category.id, discount.id))}
                                            />
                                            <div class="input-group-append">
                                                <button 
                                                    class="btn btn-secondary"
                                                    on:click={((k) => () => increment(k, 1, contingent))(build(event_id, category.id, discount.id))}
                                                    aria-label={$_("accessibility.select.unseated.discount.add", [category.name, discount.name, netto_func(discount.price)/100.0], ["category", "discount", "price"])}
                                                >
                                                    <i class="fa fa-plus" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                {:else}
                                    <div class="col-8 col-sm-4" role="cell">
                                        <span class="badge badge-danger">{ $_("unseated.sold-out") }</span>
                                    </div>
                                {/if}
                            {:else}
                                <div class="col-8 col-sm-4" role="cell" />
                            {/if}
                            <div class="col-2 d-none d-sm-block text-right price" role="cell" aria-label={$_("accessibility.select.unseated.discount.sum", [category.name, discount.name, netto_func(discount.price)/100*($catMap[build(event_id, category.id, discount.id)]|0)], ["category", "discount", "price"])}>
                                { l(netto_func(discount.price)/100*($catMap[build(event_id, category.id, discount.id)]|0)) }
                            </div>
                        </div>
                    {/each}
                {/await}
            {/each}
        </div>
    {/if}
{/await}

<style lang="less">
    :global(details) .table-header {
        @pad: 2px;
        padding-top: @pad;
        padding-bottom: @pad;
    }
    .table-body > .row > div {
        line-height: 35px;
    }
    
    .price {
        white-space: nowrap;
    }

    .input-group {
        flex-wrap: no-wrap;
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        
        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
            appearance: textfield;
        }

        label {
            width: 0;
            height: 0;
            opacity: 0;
            pointer-events: none;
        }
    }

</style>

<script lang="ts">
    function build(event_id: number, category_id: number, discount_id: number|null = null) {
        return [event_id, category_id, discount_id].filter(e => e!=null).map(e => e!.toString()).join("-")
    }

    import { Shop } from "@ticketmachine/sdk";
    import { _, PriceValue, Translator } from "@frontend/translations";
    import { catMap } from "./unseated";
    import { custom_setting } from "@/frontend/base/state";
    import { depromise } from "@/utils/svelte/proxies";
    import { readable } from "svelte/store";

    function _l(t: Translator) {
        return (value: number) => {
            return t("webshop.price", [new PriceValue(value)], ["price"]);
        }
    }
    $: l = _l($_);

    export let event: string;

    function clamp(min: number, current: number, max: number): number {
        return Math.min(max, Math.max(current, min));
    }

    function increment(key: string, amount: number, contingent: number) {
        $catMap[key] = clamp(0, ($catMap[key]||0) + amount, Math.min(contingent, max_events_config));
        $catMap = $catMap;
    }

    function updateInput(event: InputEvent, key: string, contingent: number) {
        const target = event.target as HTMLInputElement;
        let newValue = Number(target.value || "0");
        if (isNaN(newValue)) newValue = 0;

        $catMap[key] = clamp(0, newValue, Math.min(contingent, max_events_config));
        $catMap = $catMap;
    }

    $: event_id = Number(event);
    $: event_data = Shop.current.getEvent(event_id);
    $: event_obj = Shop.current.getEventPrices(event_id);
    $: max_events_config_raw = depromise(10, readable(custom_setting<number>("max_sale_count")))
    $: max_events_config = Number($max_events_config_raw) || 10

    $: netto_prices = depromise(false, readable(custom_setting<boolean>("netto_prices")))

    $: netto_func = !!$netto_prices ? ((n: number) => n / 1.19) : ((n: any) => n);
</script>


